import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PeopleIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="people" ref={ref} {...props}>
      <path d="M8,12.63A3.66,3.66,0,1,1,11.7,9,3.67,3.67,0,0,1,8,12.63ZM8,6.81A2.16,2.16,0,1,0,10.2,9,2.16,2.16,0,0,0,8,6.81ZM14.91,19a4.53,4.53,0,0,0-4.52-4.52H5.63A4.53,4.53,0,0,0,1.1,19a.75.75,0,0,0,1.5,0,3,3,0,0,1,3-3h4.76a3,3,0,0,1,3,3,.75.75,0,0,0,1.5,0Zm1.94-6.36A3.66,3.66,0,1,1,20.51,9,3.66,3.66,0,0,1,16.85,12.63Zm0-5.82A2.16,2.16,0,1,0,19,9,2.16,2.16,0,0,0,16.85,6.81ZM22.52,19A4.53,4.53,0,0,0,18,14.47H15.62a.75.75,0,0,0,0,1.5H18a3,3,0,0,1,3,3,.75.75,0,0,0,1.5,0Z" />
    </Icon>
  ),
) as IconWithRender;

PeopleIcon.displayName = 'PeopleIcon';
PeopleIcon.renderIcon = (props) => <PeopleIcon {...props} />;
export default PeopleIcon;
